export default __webpack_public_path__ + "static/media/health-symptoms.1ca97e96.svg";